import React, { useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { ChakraProvider, Flex } from '@chakra-ui/core';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'styled-components';

import './base.css';
import { Box } from '../components/neta';
import Navigation from '../components/Navigation/Navigation';
import ModalPortal from '../components/Navigation/ModalPortal';
import Footer from './Footer';
import NewsletterSignup from './NewsletterSignup';
import theme from '../styles/theme';
import ContentContainer from '../layouts/ContentContainer';

export default function Layout({ navMode, children }) {
  const { modalOpen, hasSeenMore } = useStoreState(state => state.modalDisplay);
  const { openModal, setSeenMore } = useStoreActions(actions => actions.modalDisplay);

  const helmet = React.useMemo(
    () => (
      <Helmet>
        <title>The Money Date Magazine by Zeta</title>
        <meta
          name="description"
          content="Advice on how to navigate love, life, and money in the modern age. We’ll teach you what a money date is, how to combine finances, and so much more."
        />
        <meta
          name="keywords"
          content="money management for couples, money advice for couples, couples financial planning, budgeting tips for couples"
        />
        <link rel="shortcut icon" href="/favicon.ico" />
        <link rel="alternate" href="https://www.askzeta.com" hreflang="en" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="The Money Date Magazine by Zeta" />
        <meta
          property="og:description"
          content="Advice on how to navigate love, life, and money in the modern age. We’ll teach you what a money date is, how to combine finances, and so much more."
        />
        <meta property="og:site_name" content="The Money Date Magazine by Zeta" />
        <meta property="og:url" content="https://www.askzeta.com/magazine" />
        <meta
          property="og:image"
          content="https://d142whjg6dsdg2.cloudfront.net/magazine/money-date.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://d142whjg6dsdg2.cloudfront.net/magazine/money-date.png"
        />
        <meta property="fb:app_id" content="2316257168617802" />
      </Helmet>
    ),
    []
  );

  useEffect(() => {
    const seeMoreTimer = setTimeout(() => {
      const override = window.location.search.indexOf('see-more') !== -1;
      if (override || (!hasSeenMore && !modalOpen)) {
        openModal('seeMore');
        setSeenMore();
      }
    }, 10000);

    return () => clearTimeout(seeMoreTimer);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <ChakraProvider resetCSS>
        <>
          {helmet}
          <ModalPortal />
          <Navigation mode={navMode} />
          <Box height={['0px', '60px']} />
          {children}

          <Flex bg={theme.colors.shared} className="news-letter-signup">
            <ContentContainer>
              <NewsletterSignup />
            </ContentContainer>
          </Flex>
          <Footer />
        </>
      </ChakraProvider>
    </ThemeProvider>
  );
}
